import { helpers } from '@vuelidate/validators';

const NAME_REGEX = /^[a-z\s]*$/i;
const JOIN_NOW_NAME_REGEX = /^([a-z\-']+\s)*[a-z\-']+$/i; // only allow one space between each words
const BSB_REGEX = /^\d{3}\s-\s\d{3}$/;

// eslint-disable-next-line operator-linebreak
const DATE_REGEX =
  /^(((0[1-9]|[12][0-9]|3[01])(\s\/\s)(0[13578]|1[02])|(0[1-9]|[12][0-9]|30)(\s\/\s)(0[469]|11)|(0[1-9]|1\d|2[0-8])(\s\/\s)02)(\s\/\s)\d{4}|29(\s\/\s)02(\s\/\s)(\d{2}(0[48]|[2468][048]|[13579][26])|([02468][048]|[1359][26])00))$/;

export const NAME_VALIDATOR = helpers.regex(NAME_REGEX);
export const JOIN_NOW_NAME_VALIDATOR = helpers.regex(JOIN_NOW_NAME_REGEX);
export const DATE_VALIDATOR = helpers.regex(DATE_REGEX);
export const BSB_VALIDATOR = helpers.regex(BSB_REGEX);
